

import React, { useState } from "react";
import {
    Button,
    Card,
    CardContent,
    CardActions,
    Modal,
    Typography,
    TextField
} from "@material-ui/core";

function ExcluirConsultorio({ id, title, apiUrl , AtualizarTabela }) {
    const [open, setOpen] = useState(false);
    const [observacao, setObservacao] = useState("");

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        AtualizarTabela(id)
    };

    return (
        <div>
            <Button variant="contained" color="secondary" size="small" onClick={handleOpen}>
                <i className="fas fa-remove"></i> Excluir
            </Button>
            <Modal open={open} onClose={handleClose}>
                <div
                    style={{
                        position: "absolute",
                        top: "40%",
                        left: "54%",
                        transform: "translate(-50%, -50%)",
                        width: "70%",
                        backgroundColor: "white",
                        borderRadius: '20px',
                    }}
                >
                    <Card>
                        <CardContent>
                            <Typography variant="h5">{title}</Typography>
                            <br />
                            <Typography variant="body1">
                                Por favor, informe abaixo o motivo da exclusão:
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                variant="outlined"
                                value={observacao}
                                onChange={(e) => setObservacao(e.target.value)}
                            />
                        </CardContent>
                        <CardActions>
                            <Button variant="contained" color="secondary" onClick={handleDelete}>
                                Sim, excluir
                            </Button>
                            <Button variant="contained" onClick={handleClose}>
                                Cancelar
                            </Button>
                        </CardActions>
                    </Card>
                </div>
            </Modal>
        </div>
    );
}

export default ExcluirConsultorio;
